import React, { useState } from 'react';
import { Button, Text, Title, Link, Modal } from '@gjensidige/builders-components';
import { Email } from '@gjensidige/builders-icons';
import { CallBack } from '@gjensidige/builders-icons/symbols';
import { GdprComponentSe } from '@gjensidige/gdpr-component-se';
import './SaveOfferModal.scss';
import { SaveAndSendOfferStatus } from '../../interfaces/Types';
import { AppConstants } from '../../utils/AppConstants';
import { EnquiryOptionTextBox } from '../Enquiry/EnquiryOptionTextBox';

interface SaveOfferModalProps {
  email: string;
  isActionEnabled: boolean;
  submitStatus: SaveAndSendOfferStatus;
  handleChange: (arg0: string, arg1: boolean) => void;
  handleSubmit: () => void;
  onModalClose: () => void;
}
export const SaveOfferModal: React.FC<SaveOfferModalProps> = (
  props: SaveOfferModalProps
) => {
  const [isOpen, setIsOpen] = useState(false);
  const onModalClose = (event?: any) => {
    event && event.preventDefault();
    // const documentBody = document.querySelector('body');
    // if (documentBody) {
    //   documentBody.style.overflow = !isOpen ? 'hidden' : 'auto';
    // }
    setIsOpen(!isOpen);
    props.onModalClose();
  };
  const handleChange = (
    questionType: string,
    value: string,
    isValid: boolean
  ) => {
    props.handleChange(value, isValid);
  };
  const criticalButtonAction = () => {
    props.handleSubmit();
    return false;
  };

  return (
    <div className="save-offer-wrapper">
      <div className="save-offer-link" onClick={(event) => onModalClose(event)}>
        <Email/>
        <Link href="#" className="save-offer-label ml-2">
          {AppConstants.getAppText('webshop.summary.save.saveLinkLabel')}
        </Link>
      </div>
      <Modal
        aria-label={props.submitStatus === 'succeeded' ? "Erbjudande skickat" : "Skicka erbjudande"}
        className="save-offer-input-modal"
        open={isOpen}
        strict={true}
        closeLabel={props.submitStatus === 'succeeded' ? "Stäng spara offert" : "Avbryt att skicka prisuppgift"}
        onClose={onModalClose}
        size="sm"
      >
        {props.submitStatus === 'succeeded' ? (
          <div className="success-info-wrapper pt-3">
            <div className="success-illustration">
              {/* <img
                src={props.illustrationUrl}
                alt="send offer email success image"
              /> */}
              <CallBack width="150" height="150"/>
            </div>
            <Text size="body" className="success-info mt-5">
              {AppConstants.getAppText('webshop.summary.save.successInfo')}
            </Text>
            <Text size="body" className="email-sent">{props.email}</Text>
            <Text size="body" className="bottom-message pt-2">
              {AppConstants.getAppText(
                'webshop.summary.save.successBottomInfo'
              )}
            </Text>
          </div>
        ) : (
          <div className="save-offer-modal-content">
            <Title as="h2" size="5">
              {AppConstants.getAppText('webshop.summary.save.modalHeader')}
            </Title>
            <Text size="body" className="save-offer-info pt-1" dangerouslySetInnerHTML={{
                  __html: AppConstants.getAppText('webshop.summary.save.modalContent')
              }}>
              
            </Text>
            <div className="save-offer-inputs pt-2">
              <EnquiryOptionTextBox
                questionType="email"
                labelText={AppConstants.getAppText(
                  'webshop.summary.save.emailLabelText'
                )}
                placeholderText={AppConstants.getAppText(
                  'webshop.summary.save.emailPlaceHolder'
                )}
                selectedValue={props.email}
                name="save-offer-email"
                postfixText=""
                handleChange={handleChange}
                disabled={props.submitStatus === 'pending'}
                errorMessage={
                  props.submitStatus === 'failed'
                    ? AppConstants.getAppText(
                        'webshop.summary.save.saveFailedMessage'
                      )
                    : ''
                }
                isValid={
                  props.submitStatus !== 'failed' && props.isActionEnabled
                }
              />
            </div>
            <Text size="body" className="personal-info-process pt-1">
              <GdprComponentSe />
            </Text>
            <div className="bottom-panel-wrapper">
              <Button
                onClick={criticalButtonAction}
                className="mb-2 mt-3"
                variant="primary"
                size="md"
                type="button"
                disabled={!props.isActionEnabled}
                loading={props.submitStatus === 'pending'}
              >
                {AppConstants.getAppText('webshop.summary.save.sendButtonLabel')}
              </Button>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
};
